import * as React from "react";
function ClubhouseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.742 17.875c-.959 0-1.742.783-1.742 1.742 0 .958.783 1.741 1.742 1.741a1.74 1.74 0 100-3.483zM23.183 2.667l-10.966 3.5V2.708L.392 6.483v10.025l10.2-3.258v3.442L24 12.417l-3.633-3.55 2.816-6.2zm-12.591 8.866l-8.567 2.734V7.675l8.567-2.733v6.591zm10.375.142l-8.75 2.792V7.883l8.058-2.575-1.85 3.9 2.542 2.467z"
  }));
}
const ForwardRef = React.forwardRef(ClubhouseIcon);
export default ForwardRef;